export function interviewMapper(response) {
  const isPrimary = response.isPrimary === undefined ? true : response.isPrimary;

  const progress = response.template.pages.map((page) => {
    return {
      interviewName: 'onbord',
      pageName: page.name,
      lastCompleted: page.filled ? page.filled : null,
      instance: page.data ? page.data.instance : null,
      id: page._id,
      label: page.data ? page.data.label : null,
      status: page.status ? page.status : null,
      accountId: null,
      clientInterviewId: page._id,
      data: page.data,
    };
  });

  return {
    companyLogo: response.organisationLogo,
    progress,
    uploads: response.documents,
    isPrimary,
    // Security: All contact PII removed (names, phone, email)
    // Legacy features adapted to work without this data
  };
}
